export default "__VITE_ASSET__cd7f0f5d__"